import { render, staticRenderFns } from "./CharacterFolderList.vue?vue&type=template&id=e0678d0e&scoped=true"
import script from "./CharacterFolderList.vue?vue&type=script&lang=ts"
export * from "./CharacterFolderList.vue?vue&type=script&lang=ts"
import style0 from "./CharacterFolderList.vue?vue&type=style&index=0&id=e0678d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0678d0e",
  null
  
)

export default component.exports